import React from "react";

import PropTypes from "prop-types";

import RbFlexTableBodyContext from "./RbFlexTableBodyContext";

const RbFlexTableBody = React.forwardRef(function RbFlexTableBody(props, ref) {
  const { children, ...other } = props;

  const contextValue = React.useMemo(() => {
    return {
      body: true,
    };
  }, []);

  const renderChildren = () => {
    return React.Children.map(children, (row, index) => {
      return React.cloneElement(row, { index });
    });
  };

  return (
    <RbFlexTableBodyContext.Provider value={contextValue}>
      <div role="rowgroup" {...other} ref={ref}>
        {renderChildren()}
      </div>
    </RbFlexTableBodyContext.Provider>
  );
});

RbFlexTableBody.propTypes = {
  children: PropTypes.node,
};

RbFlexTableBody.defaultProps = {
  children: null,
};

export default React.memo(RbFlexTableBody);
